import { createApp } from "vue";

import './../admin/utility/IPAddress'

import './integration/cf7'
import './integration/gravityforms'
import './integration/wpforms'
import './integration/fluentform'
import './integration/forminator'
import './integration/formidable'
import './integration/ninjaforms'

import App from "./App.vue";

(() => {
    const app = createApp(App);
    app.mount("#formychat-widgets");
})();